import { useCopy } from "@/hooks/useCopy"
import { useToast } from "@/provider/ToastProvider"
import { useTranslations } from "next-intl"
import { ReactNode, useEffect } from "react"


export const CopyWrapper = ({ render, onCopied }: {
  render: (copy: (text: string) => void) => ReactNode
  onCopied?: () => void
}) => {
  const { copy, isSupported } = useCopy()

  const t = useTranslations()
  const { showToast } = useToast()

  const _copy = (text: string) => {

    if (!isSupported) {
      showToast({ message: t('common.copyError'), type: 'error' })
      return
    }

    copy(text, {
      onSucess() {
        onCopied?.()
      }, onError() {
      }
    })

  }



  return (
    <>
      {render(_copy)}
    </>
  )
}